export const openToLink = (type,data) => {
  let href = null;
  console.log('openToLink----',type,data)
// return
  switch (type) {
    case "category": //分类
      href = `/#/goods?categoryId=${data.id}`;
      break;
    case "goods": //商品
      href = `/#/goodsDetails?itemId=${data.id}`;
      break;
    case "store": //店铺
      href = `/#/store/home?id=${data.id}`;
      break;
    case "tag": //标签
      href = `/#/goods?tagId=${data.id}`;
      break;
    case "article": //文章
      href = `/#/article?articleId=${data.id}`;
      break;
    case "link": //页面
      href = `/#/user/paidMbr`;
      break;
    case "custom_page": //自定义页面
      href = `/#/custompage?itemId=${data.id}`;
      break;
    default:
      break;
  }
  window.open("//" + window.location.host + href);
}



// WEBPACK FOOTER //
// ./src/utils/openToLink.js